import React from 'react';
import { EntitiesIcon } from '../../../../../design/icons/entities.icon';
import classNames from 'classnames';
import styles from './entities-assigned.module.css';
import { IEntitiesAssignedWidgetProps } from './entities-assigned.models';
import { AssessmentAssigneeType } from '../../../../../enums';
import { SkeletonOverlay } from '../../../../../components/general/loading-state/skeleton-overlay';
import { AssessmentSubType } from '../../../../../enums/assessment-type';
import { RatingEntityIcon } from '../../../../../design/icons/rating-entity.icon';

function getEntityName(entityType: AssessmentAssigneeType, totalEntities: number): string {
  switch (entityType) {
    case AssessmentAssigneeType.Company:
      return `Company`;
    case AssessmentAssigneeType.Department:
      return `Department${totalEntities > 1 ? 's' : ''}`;
    case AssessmentAssigneeType.Team:
      return `Team${totalEntities > 1 ? 's' : ''}`;
    default:
      return totalEntities !== 1 ? 'People' : 'Person';
  }
}

export function EntitiesAssignedWidget({ isLoading, entityType, overviewData, peerOverview }: IEntitiesAssignedWidgetProps): React.ReactElement {
  const { assessmentSubType, assigneeTypeCount, userCount } = overviewData;

  return (
    <SkeletonOverlay isLoading={isLoading} width="100%" height="100%">
      <div className={classNames('card', styles.card)}>
        {assessmentSubType === AssessmentSubType.RatingAssessment ? (
          <React.Fragment>
            <RatingEntityIcon size={80} />

            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
              <div>{peerOverview?.numberOfAssignees ?? 0} {peerOverview?.numberOfAssignees !== 1 ? 'Subjects' : 'Subject'} </div>
              <small>{peerOverview?.numberOfAssessors ?? 0} {peerOverview?.numberOfAssessors !== 1 ? 'Assessors' : 'Assessor'}</small>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <EntitiesIcon size={80} />

            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
              <div> {`${assigneeTypeCount} ${getEntityName(entityType, assigneeTypeCount)}`} </div>
              {entityType !== AssessmentAssigneeType.Learner && (
                <small>{`${userCount} ${userCount !== 1 ? 'Participants' : 'Participant'}`}</small>
              )}
            </div>
          </React.Fragment>
        )}
      </div>
    </SkeletonOverlay>
  );
}
